import getCardsTotal from './getCardsTotal';
import getMVByAccType from './getMVByAccType';
import getTopPlatformTotal from './getTopPlatformTotal';
import getTopPlatformGraph from './getTopPlatformGraph';
import getTopPlacementTotal from './getTopPlacementTotal';
import getTopPlacementGraph from './getTopPlacementGraph';
import getTopSocialPosts from './getTopSocialPosts';

import combineActions from '../../utils/combineActions';

export default combineActions({
    getCardsTotal,
    getMVByAccType,
    getTopPlacementTotal,
    getTopPlacementGraph,
    getTopPlatformTotal,
    getTopPlatformGraph,
    getTopSocialPosts,
});
